<template>
<div class="chapter">
<div class="inner_page">
<p class="cip-break"><a id="pIV"></a>Published with assistance from the Kingsley Trust Association Publication Fund established by the Scroll and Key Society of Yale College.</p>
<p class="cip-spaced">English translation © 2016 by Yale University. Translated 2016 by Stephanie O’Hara.</p>
<p class="cip">Originally published as <i>Août 14.</i> © Éditions <span class="fsc">GALLIMARD</span>, Paris, 2014.</p>
<p class="cip">Map by Bill Nelson.</p>
<p class="cip-spaced">All rights reserved.</p>
<p class="cip">This book may not be reproduced, in whole or in part, including illustrations, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press), without written permission from the publishers.</p>
<p class="cip-spaced">Yale University Press books may be purchased in quantity for educational, business, or promotional use. For information, please e-mail <a href="mailto:sales.press@yale.edu">sales.press@yale.edu</a> (U.S. office) or <a href="mailto:sales@yaleup.co.uk">sales@yaleup.co.uk</a> (U.K. office).</p>
<p class="cip-spaced">Set in Janson Roman type by IDS Infotech, Ltd.</p>
<p class="cip">Printed in the United States of America.</p>
<p class="cip-spaced">Library of Congress Control Number: 2015959532</p>
<p class="cip">ISBN 978-0-300-20827-6 (hardcover : alk. paper)</p>
<p class="cip-spaced">A catalogue record for this book is available from the British Library.</p>
<p class="cip-spaced">This paper meets the requirements of ANSI/NISO Z39.48-1992 (Permanence of Paper).</p>
<p class="cip-spaced">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?7899a2e8